import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import IconShield from 'venuescanner-js/react/components/Objects/Icons/IconShield';
import IconLogo from 'venuescanner-js/react/components/Objects/Icons/IconLogo';

import {
  EnquiryInfoItem,
  EnquiryInfoItems,
} from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoItem';
import { CancellationPolicyModal } from './CancellationPolicyModal';
import { PaymentInfo } from './PaymentInfo';
import { DateEnquiryInfo, TimeEnquiryInfo } from './TimeEnquiryInfoItems';
import { ReviewIoWidget } from './ReviewIoWidget';

export function OrganiserEnquiryInfo({ state, thread, venue }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onCancellationPolicyClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const cancellationPolicy = venue.cancellation_policy;

  return (
    <Stack direction='column' spacing={2}>
      <div className='enquiry-info'>
        <EnquiryInfoItems>
          <EnquiryInfoItem
            title='Guests'
            value={thread.cumulativeOffer.capacity}
          />
          <DateEnquiryInfo value={thread.localDates} />
          <TimeEnquiryInfo value={thread.localDates} />
          {(state.matches('quoteReceived') || state.matches('booked')) && (
            <PaymentInfo thread={thread} />
          )}
        </EnquiryInfoItems>
      </div>
      {state.matches('quoteReceived') && (
        <Stack
          spacing={1.5}
          className='enquiry-info'
          direction='row'
          sx={{ flexDirection: 'row' }}>
          <Typography sx={{ fontSize: 14, lineHeight: 1.3 }}>
            Bookings are covered by the venue&apos;s&nbsp;
            <Button
              variant='text'
              color='primary'
              sx={{
                p: 0,
                textDecoration: 'underline',
                fontSize: 'inherit',
                lineHeight: 'inherit',
              }}
              onClick={onCancellationPolicyClick}>
              cancellation policy
            </Button>
            &nbsp;and VenueScanner&apos;s&nbsp;
            <Link
              to='/terms-and-conditions'
              rel='noreferrer noopener'
              target='_blank'>
              terms & conditions
              <span className='visually-hidden'>(opens in new tab)</span>
            </Link>
          </Typography>
          <Box
            sx={{
              flex: '0 0 24px',
              maxWidth: '24px',
              justifyContent: 'flex-end',
            }}
            aria-hidden='true'>
            <IconShield />
          </Box>
          <CancellationPolicyModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            cancellationPolicy={cancellationPolicy}
          />
        </Stack>
      )}
      {state.matches('quoteReceived') && (
        <Stack className='enquiry-info' direction='column' spacing={1.5}>
          <Stack spacing={0.5} alignItems='center' direction='row'>
            <Typography sx={{ fontSize: 14, lineHeight: 1.3 }}>
              Customers love
            </Typography>
            <div aria-labelledby='logo-label'>
              <span id='logo-label' hidden>
                VenueScanner
              </span>
              <IconLogo aria-hidden={true} width='120px' height='20px' />
            </div>
          </Stack>
          <Box>
            <ReviewIoWidget
              sx={{
                '& iframe': {
                  minWidth: '272px !important',
                  marginLeft: '-18px',
                  marginTop: '-10px',
                  marginRight: '10px'
                }
              }}
            />
          </Box>
        </Stack>
      )}
    </Stack>
  );
}
